/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
// babel-polyfill is deprecated in Babel 7 in favor of importing core-js/regenerator-runtime
// directly -- same effect (polyfills + generator/async support for older browsers).
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// font-awesome was previously pulled in via the font-awesome-webpack loader as a
// separate webpack entry (see the old webpack/dev.config.js and prod.config.js
// entry arrays). font-awesome-webpack hasn't been updated in years and its whole
// purpose was letting you selectively include icon subsets to shrink the bundle --
// given the size of this app already, that's not worth preserving. This just
// imports the full precompiled CSS instead, which is simpler and works with the
// plain css-loader pipeline already in place.
import 'font-awesome/css/font-awesome.min.css'
import React from 'react'
import ReactDOM from 'react-dom'
import createStore from './redux/create'
import ApiClient from './helpers/ApiClient'
import {Provider} from 'react-redux'
import convert from './helpers/convert'
import { applyRouterMiddleware, Router, browserHistory} from 'react-router'
// import useScroll from 'scroll-behavior/lib/useStandardScroll'
import useScroll from 'react-router-scroll'
import { syncHistoryWithStore } from 'react-router-redux'
import { ReduxAsyncConnect } from 'redux-async-connect'
import getRoutes from './routes'
import config from './config'
import ReactGA from 'react-ga4'


if( convert.boolean(config.loggingOff)){
  console.log = () =>{}
}

const client = new ApiClient()
// const _browserHistory = useScroll(() => browserHistory)()
const _browserHistory = browserHistory
const dest = document.getElementById('content')
const store = createStore(_browserHistory, client, window.__data)
const history = syncHistoryWithStore(_browserHistory, store)

if (config.gaKey) {
  console.log('gaKey:',config.gaKey)
  ReactGA.initialize([
    {
      trackingId: config.gaKey
    }
  ])
}

// scroll to the top or not?
const scrollBehavior = useScroll((prevRouterProps, { location }) => {
  // console.log('location:',location.pathname, prevRouterProps.location.pathname )
  return prevRouterProps && location.pathname !== prevRouterProps.location.pathname
})

let lastUrl = null
function logPageView() {
  const url = window.location.pathname + window.location.search + window.location.hash
  // we're saving and checking last url bc
  // react-router is calling onUpdate twice for initial load
  // don't send if lastUrl is null;
  // because it's logging that page on ReactGA.initialize above.
  if (lastUrl !== url && lastUrl !== null) {
    console.log('GA url:', url)
    // set title to url to avoid 'off-by-one' title issue.
    // not perfect solution, because initial page load sends window title;
    // but at least it's accurate.
    ReactGA.send({ hitType: "pageview", page: url, title: url });
    lastUrl = url
  } else {
    lastUrl = url
  }
}

function hashLinkScroll() {
  const { hash } = window.location;
  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
}
function hashLinkScrollLogView() {
  hashLinkScroll()
  // if( config.gaKey ) {
  //   logPageView()
  // }
}

const component = (
  <Router
     render={(props) =>
        <ReduxAsyncConnect {...props} helpers={{client}} filter={item => !item.deferred}
          render={applyRouterMiddleware(scrollBehavior)}
        />
      }
      history={history}
      onUpdate={hashLinkScrollLogView}
     >
    {getRoutes(store)}
  </Router>
)

ReactDOM.render(
  <Provider store={store} key="provider">
    {component}
  </Provider>,
  dest
)

if (process.env.NODE_ENV !== 'production') {
  window.React = React // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.')
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  const DevTools = require('./containers/DevTools/DevTools')
  ReactDOM.render(
    <Provider store={store} key="provider">
      <div>
        {component}
        <DevTools />
      </div>
    </Provider>,
    dest
  )
}
